import axios from "axios";
import {PIC_POSITIONS_LIST_URL} from '../../config/pth.links'
import {toast} from 'react-toastify'

export const FETCH_PTH_PIC_POSITIONS_LIST = 'FETCH_PTH_PIC_POSITIONS_LIST'
export const RECEIVE_PTH_PIC_POSITIONS_LIST = 'RECEIVE_PTH_PIC_POSITIONS_LIST'
export const FAILED_PTH_PIC_POSITIONS_LIST = 'FAILED_PTH_PIC_POSITIONS_LIST'

export function fetchPthPicPositions(){    return (dispatch, getState) => {
        
            let {authStore} = getState();
            let auth = null;
            if(authStore.authData){
                auth = authStore.authData.result.token;
            }
        dispatch({type: FETCH_PTH_PIC_POSITIONS_LIST});
        axios({
            method: 'post',
            url: PIC_POSITIONS_LIST_URL,
            headers: {
                Authorization: auth
            },
        })
        .then((response) => {
            dispatch( {
                type: RECEIVE_PTH_PIC_POSITIONS_LIST,
                payload: response.data
            })
        })
        .catch(function(error){
            if (error.response) {
                if(error.response.status === 401) {
                    dispatch({
                        type: FAILED_PTH_PIC_POSITIONS_LIST
                    })
                    return toast.error("Invalid username or password! Please try again!");
                } else if (error.response.status === 404 || error.response.status === 500) {
                    dispatch({
                        type: FAILED_PTH_PIC_POSITIONS_LIST
                    })
                    return toast.error("Server cannot be contacted! Please ask your system administrator!");
                } else if (error.response.status === 400) {
                    dispatch({
                        type: FAILED_PTH_PIC_POSITIONS_LIST
                    })
                    return toast.error(error.response.data.message);
                } else {
                    dispatch({
                        type: FAILED_PTH_PIC_POSITIONS_LIST
                    })
                    return toast.error('Something went wrong... Please try again later...');
                }
            } else if (error.request) {
                dispatch({
                    type: FAILED_PTH_PIC_POSITIONS_LIST
                })
                return toast.error('Request error! Please try again later...')
            } else {
                dispatch({
                    type: FAILED_PTH_PIC_POSITIONS_LIST
                })
                return toast.error('Something went wrong... Please try again later...')
            }
        })
    }
}